import { z } from 'zod';
export const exchangeRateRangeSchema = z
    .object({ start: z.iso.date(), end: z.iso.date() })
    .refine(({ start, end }) => {
    const days = (Date.parse(`${end}T00:00:00Z`) - Date.parse(`${start}T00:00:00Z`)) / 86_400_000 + 1;
    return days >= 1 && days <= 366;
}, 'Choose an ordered period of at most 366 days.');
export const exchangeRateCoverageResponseSchema = z.object({
    data: z.object({
        startDate: z.iso.date(),
        endDate: z.iso.date(),
        fromCurrency: z.literal('USD'),
        toCurrency: z.literal('CAD'),
        coverageDays: z.number().int().nonnegative(),
        expectedDays: z.number().int().nonnegative(),
        missingDays: z.array(z.iso.date()),
        latestRateDate: z.iso.date().nullable(),
        observations: z.array(z.object({
            date: z.iso.date(),
            rateScaled: z.number().int().positive(),
            scale: z.literal(1_000_000),
            source: z.string(),
        })),
    }),
});
export const exchangeRateResyncResponseSchema = z.object({
    data: z.object({
        status: z.literal('queued'),
        runId: z.uuid(),
        requested: exchangeRateRangeSchema,
    }),
});
//# sourceMappingURL=exchange-rates.js.map